import React from 'react';
import CgInfoHint from 'modules/Common/ui/CgInfoHint';

export default function CgFormLabel({ formControl }) {
  // Pre-emptive: `formControl.infoText` is set by no form config in the tree
  // today (the live v1 help affordance is FormControlTypes.Trigger → CgPopover
  // in CgFormGroup), so this branch never renders. Plumbed anyway so it is
  // already correct the day someone sets it.
  var isRequired = formControl.validation && !formControl.validation.isOptional();
  const labelClassName = formControl.labelClassName || 'ml-3';

  return (
    <label
      htmlFor={formControl.key}
      className={labelClassName}
    >
      {formControl.label}
      {isRequired && <> *</>}
      {formControl.infoText && (
        <>
          {' '}
          <CgInfoHint
            position="top"
            subject={formControl.label}
            popoverContentClassName="z-[100160]"
          >
            {formControl.infoText}
          </CgInfoHint>
        </>
      )}
    </label>
  );
}
